
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyBzA6IzMaDQZpzDPF10wLYkBUUCgCY9i2Y",
    authDomain: "frontera.app",
    projectId: "projectfinder-cdb83",
    storageBucket: "projectfinder-cdb83.appspot.com",
    messagingSenderId: "134567899998",
    appId: "1:134567899998:web:abc123xyz456def7890"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };
